// extracted by mini-css-extract-plugin
module.exports = {"customSpin":"CustomSpin_customSpin__5dS9k"};